"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textareaNeoDark = exports.textareaNeoLight = exports.textareaNovoDark = exports.textareaNovo = exports.textarea = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const textarea = {
    textareaFontFamily: font_const_1.default.family,
    textareaFontSize: font_const_1.default.sizeSm,
    textareaFontStyle: 'normal',
    textareaFontWeight: font_const_1.default.weightDefault,
    textareaLetterSpacing: 'normal',
    textareaLineHeight: font_const_1.default.lineHeightSm,
    textareaWidth: '100%',
    textareaColor: color_const_1.default.pickledBluewood800,
    textareaColorReadOnly: color_const_1.default.steel700,
    textareaColorDisabled: color_const_1.default.cloudyBlue,
    textareaPlaceholderColor: color_const_1.default.cloudyBlue,
    textareaBackgroundColor: color_const_1.default.white,
    textareaBackgroundColorDisabled: color_const_1.default.cloudyBlue100,
    textareaBackgroundColorReadOnly: color_const_1.default.white,
    textareaBorderColor: color_const_1.default.cloudyBlue300,
    textareaBorderColorReadOnly: color_const_1.default.cloudyBlue300,
    textareaBorderColorDisabled: color_const_1.default.cloudyBlue300,
    textareaBorderColorFocus: color_const_1.default.dodgerBlue,
    textareaBorderColorError: color_const_1.default.coral,
    textareaBorderRadius: 0,
    textareaBorderRadiusReadOnly: 0,
    borderWidth: '1px',
    borderWidthReadOnly: '1px',
    textareaPadding: spacing_const_1.default.xs,
    textareaPaddingReadOnly: spacing_const_1.default.xs,
    textareaTransitionTiming: timing_const_1.default.fast,
};
exports.textarea = textarea;
const textareaNovo = {
    textareaFontFamily: light.body01.fontFamily,
    textareaFontSize: light.body01.fontSize,
    textareaFontStyle: 'normal',
    textareaFontWeight: light.body01.fontWeight,
    textareaLetterSpacing: light.body01.letterSpacing,
    textareaLineHeight: light.body01.lineHeight,
    textareaWidth: '100%',
    textareaColor: light.textColor01,
    textareaColorReadOnly: light.textColor01,
    textareaColorDisabled: light.disabled02,
    textareaPlaceholderColor: light.textColor02,
    textareaBackgroundColor: light.ui05,
    textareaBackgroundColorDisabled: light.ui05,
    textareaBackgroundColorReadOnly: light.ui06,
    textareaBorderColor: light.ui05,
    textareaBorderColorReadOnly: 'transparent',
    textareaBorderColorDisabled: light.ui05,
    textareaBorderColorFocus: light.focus01,
    textareaBorderColorError: light.action03,
    borderWidth: '2px',
    borderWidthReadOnly: '2px',
    textareaBorderRadius: '6px',
    textareaBorderRadiusReadOnly: '6px',
    textareaPadding: '6px 14px',
    textareaPaddingReadOnly: '6px 0',
    textareaTransitionTiming: '150ms',
};
exports.textareaNovo = textareaNovo;
const textareaNovoDark = {
    ...textareaNovo,
    textareaColor: dark.textColor01,
    textareaColorReadOnly: dark.textColor01,
    textareaColorDisabled: dark.disabled02,
    textareaPlaceholderColor: dark.textColor02,
    textareaBackgroundColor: dark.ui05,
    textareaBackgroundColorDisabled: dark.ui05,
    textareaBackgroundColorReadOnly: dark.ui06,
    textareaBorderColor: dark.ui05,
    textareaBorderColorReadOnly: dark.ui01,
    textareaBorderColorDisabled: dark.ui05,
    textareaBorderColorFocus: dark.focus01,
    textareaBorderColorError: dark.action03,
};
exports.textareaNovoDark = textareaNovoDark;
const textareaNeoLight = {
    ...textareaNovo,
    textareaColor: neoLight.textColor01,
    textareaColorReadOnly: neoLight.textColor01,
    textareaColorDisabled: neoLight.disabled02,
    textareaPlaceholderColor: neoLight.textColor02,
    textareaBackgroundColor: neoLight.ui05,
    textareaBackgroundColorDisabled: neoLight.ui05,
    textareaBackgroundColorReadOnly: neoLight.ui06,
    textareaBorderColor: neoLight.ui05,
    textareaBorderColorDisabled: neoLight.ui05,
    textareaBorderColorFocus: neoLight.focus01,
    textareaBorderColorError: neoLight.action03,
};
exports.textareaNeoLight = textareaNeoLight;
const textareaNeoDark = {
    ...textareaNovoDark,
    textareaColor: neoDark.textColor01,
    textareaColorReadOnly: neoDark.textColor01,
    textareaColorDisabled: neoDark.disabled02,
    textareaPlaceholderColor: neoDark.textColor02,
    textareaBackgroundColor: neoDark.ui05,
    textareaBackgroundColorDisabled: neoDark.ui05,
    textareaBackgroundColorReadOnly: neoDark.ui06,
    textareaBorderColor: neoDark.ui05,
    textareaBorderColorReadOnly: neoDark.ui01,
    textareaBorderColorDisabled: neoDark.ui05,
    textareaBorderColorFocus: neoDark.focus01,
    textareaBorderColorError: neoDark.action03,
};
exports.textareaNeoDark = textareaNeoDark;
